module.exports = __webpack_public_path__ + "static/media/menulink2.545e047d.jpg";